import React, { createContext, useEffect, useReducer, useState } from "react";

// third-party
import { Chance } from "chance";
import jwtDecode from "jwt-decode";

// reducer - state management
import { LOGIN, LOGOUT } from "store/reducers/actions";
import authReducer from "store/reducers/auth";

// project import
import Loader from "components/Loader";
import axios from "utils/axios";
import { KeyedObject } from "types/root";
import { AuthProps, JWTContextType } from "types/auth";
import Cookies from "js-cookie";
import { decrypt, getDomainName } from "utils/commonFunctions";
const chance = new Chance();

// constant
const initialState: AuthProps = {
  isLoggedIn: false,
  isInitialized: false,
  user: null,
};

const verifyToken: (st: string) => boolean = (serviceToken) => {
  if (!serviceToken) {
    return false;
  }
  const decoded: KeyedObject = jwtDecode(serviceToken);
  /**
   * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
   */
  return decoded.exp > Date.now() / 1000;
};

const setSession = (serviceToken?: string | null) => {
  if (serviceToken) {
    localStorage.setItem("serviceToken", serviceToken);
    axios.defaults.headers.common.Authorization = `Bearer ${serviceToken}`;
  } else {
    localStorage.removeItem("serviceToken");
    delete axios.defaults.headers.common.Authorization;
  }
};

// ==============================|| JWT CONTEXT & PROVIDER ||============================== //

const JWTContext = createContext<JWTContextType | null>(null);
const domain = getDomainName();
const isIONetgateDomain = domain.includes('io-netgate');
// const isIOMDomain = domain.includes('io-market');


export const JWTProvider = ({ children }: { children: React.ReactElement }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);
  // const [companyId, setComapanyId] = useState(() => isIONetgateDomain ? Cookies.get(process.env.REACT_APP_INSTANCE_COOKIE|| "") : Cookies.get(process.env.REACT_APP_LOGIN_COOKIE|| "") || null);
  const [companyId, setComapanyId] = useState(null);

  useEffect(()=>{
    const cookieData = isIONetgateDomain ? Cookies.get(process.env.REACT_APP_LOGIN_COOKIE || "") : Cookies.get(process.env.REACT_APP_EXPIRE_COOKIE || "") || null
    if (cookieData) {
      if (isIONetgateDomain) {
        const loginCookie = cookieData ? JSON.parse(decrypt(cookieData)) : null;
        console.log("cookieExist", loginCookie?.netcomid);
        setComapanyId(loginCookie?.netcomid ? loginCookie?.netcomid:loginCookie?.companyId)
      } else {
        const userExpireData = decodeURIComponent(cookieData);
        const userDetails = JSON.parse(decrypt(userExpireData));
        console.log("cookieExist", userDetails.netcomId);
        setComapanyId(userDetails.netcomId);
      }
    }
  },[])

  useEffect(() => {
    const init = async () => {
      try {

        const serviceToken = window.localStorage.getItem("serviceToken");
        if (serviceToken && verifyToken(serviceToken)) {
          setSession(serviceToken);
          // const response = await axios.get("/api/account/me");
          // const { user } = response.data;
          dispatch({
            type: LOGIN,
            payload: {
              isLoggedIn: true,
              // user,
            },
          });
        } else {
          dispatch({
            type: LOGOUT,
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: LOGOUT,
        });
      }
    };

    init();
  }, []);

  const login = async (email: string, password: string) => {
    const response = await axios.post("/api/account/login", {
      email,
      password,
    });
    const { serviceToken, user } = response.data;
    setSession(serviceToken);
    dispatch({
      type: LOGIN,
      payload: {
        isLoggedIn: true,
        user,
      },
    });
  };

  const register = async (
    email: string,
    password: string,
    firstName: string,
    lastName: string
  ) => {
    // todo: this flow need to be recode as it not verified
    const id = chance.bb_pin();
    const response = await axios.post("/api/account/register", {
      id,
      email,
      password,
      firstName,
      lastName,
    });
    let users = response.data;

    if (
      window.localStorage.getItem("users") !== undefined &&
      window.localStorage.getItem("users") !== null
    ) {
      const localUsers = window.localStorage.getItem("users");
      users = [
        ...JSON.parse(localUsers!),
        {
          id,
          email,
          password,
          name: `${firstName} ${lastName}`,
        },
      ];
    }

    window.localStorage.setItem("users", JSON.stringify(users));
  };

  const logout = () => {
    setSession(null);
    dispatch({ type: LOGOUT });
  };

  const resetPassword = async (email: string) => { };

  const updateProfile = () => { };

  if (state.isInitialized !== undefined && !state.isInitialized) {
    return <Loader />;
  }

  return (
    <JWTContext.Provider
      value={{
        ...state,
        login,
        logout,
        register,
        resetPassword,
        updateProfile,
        companyId
      }}
    >
      {children}
    </JWTContext.Provider>
  );
};

export default JWTContext;
